<script setup>

</script>
<template>
<i>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M18.909 17.0909C18.909 17.4767 18.7557 17.8467 18.483 18.1194C18.2102 18.3922 17.8402 18.5455 17.4544 18.5455H5.81807C5.4323 18.5455 5.06233 18.3922 4.78955 18.1194C4.51677 17.8467 4.36353 17.4767 4.36353 17.0909V6.9091C4.36353 6.52334 4.51677 6.15337 4.78955 5.88059C5.06233 5.60781 5.4323 5.45456 5.81807 5.45456H9.45443L10.909 7.63638H17.4544C17.8402 7.63638 18.2102 7.78962 18.483 8.0624C18.7557 8.33518 18.909 8.70515 18.909 9.09092V17.0909Z" fill="white" stroke="#174FDC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</i>
</template>
<style scoped>

</style>